import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { Typography } from "@mui/material";
import { UnauthenticatedLayout } from "Components/Layout/UnauthenticatedLayout";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { useNavigate } from "Navigation/useNavigate";
import { resetUser } from "State/Auth/AuthReducer";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { useDispatch } from "react-redux";
import styled from "styled-components";

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const StyledIcon = styled(NotInterestedIcon)`
  margin: 20px;
  font-size: 120px;
`;

export const Error403Page = () => {
  const { t } = useResource();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <UnauthenticatedLayout title="403">
      <StyledPage>
        <Typography variant="h1">Error 403</Typography>
        <Typography variant="h2">
          {t(Resources.Errors.Error403.Subtitle)}
        </Typography>
        <StyledIcon />
        <PrimaryButton
          onClick={() =>
            dispatch(
              resetUser({
                onAfterReset: () =>
                  navigate(appUrl("sign-in"), { replace: true }),
              }),
            )
          }
        >
          {t(Resources.Pages.Content.Error403.Logout)}
        </PrimaryButton>
      </StyledPage>
    </UnauthenticatedLayout>
  );
};

export default Error403Page;
